<template>
  <div class="overall-bg pb-0">
    <b-container>
      <b-row>
        <b-col>
          <BackToMasters :flag="5" :goback="$router.back"></BackToMasters>
          <Headerlayout :headertext="$t('reorder.title')" :contenttext="$t('userManagement.codeTemplate.content')" />
        </b-col>
      </b-row>
    </b-container>
  </div>
  <div class="overall-bg pt-0">
    <b-container>
      <div class="form-white-bg">
        <b-row>
          <b-row class="pb-0 align-items-center">
            <b-col lg="2" md="4" sm="6">
              <div class="field">
                <Datepickers :label="$t('ItemCategory.RateContract.fromdate')" :maxDate="TodayDate"
                  dateFormat="dd-mm-yy" v-model="ItemData.FromDate" name="FromDate" id="FromDate"
                  @date-select="IsdateClear()" :required-icon="true" />
              </div>
            </b-col>
            <b-col lg="2" md="4" sm="6">
              <div class="field">
                <Datepickers :label="$t('ItemCategory.RateContract.todate')" :maxDate="TodayDate" dateFormat="dd-mm-yy"
                  v-model="ItemData.ToDate" name="ToDate" id="ToDate" :minDate="ItemData.FromDate"
                  @date-select="IsShowByStockTransIdPO()" :disabled="todateDisabled" :required-icon="true" />
              </div>
            </b-col>
            <b-col lg="2" md="4" sm="6">
              <!-- <div class="field"> -->
              <AddButton btnname="Set Reorder Level" @Click="setReorderlevel()" />
              <!-- </div> -->
            </b-col>
            <!-- <b-col lg="3" md="4" sm="6">
              <div class="field">
                <StoreDropDown label="Store" name="Store" id="Store" v-model="StoreDropdown.StoreId" :storetype="0"
                  :filterId="StoreID" @update:modelValue="() => { SelectStore(StoreDropdown.StoreId), StoreOnChange() }"
                  :showClear="false"
                  :rules="{ required: true }" :required-icon="true" />
              </div>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col class="position-relative prtable">
              <div>
                <b-row class="actioncardbg" v-if="QueryStringValue3.Type == 1">
                  <b-col lg="5" md="5">
                    <div class="d-flex align-items-center justify-content-around">
                      <p class="selectedcount">
                        {{ POselectedProductCount }} Selected
                      </p>
                      <div>
                        <span class="p-input-icon-left card-search">
                          <i class="pi pi-search pb-0" />
                          <TextField @keyup="ItemSearchFunction()" v-model="SearchValue.inputValue" type="text"
                            placeholder="Search Item" clearable name="Search Item" :rules="{ required: false }"
                            id="Box Name" :required-icon="false" label="p" />
                        </span>
                      </div>
                    </div>
                  </b-col>

                  <b-col lg="7" md="7" class="d-flex align-items-center justify-content-end gap-2">
                    <div class="label-d-none field prtopo my-auto">
                      <CustomDropdown @update:modelValue="FilterCategoryOnChange"
                        v-model="FilterCategoryDropdown.CategoryId" :items="FilterCategoryDropdown.CategoryOptions"
                        :rules="{ required: false }" placeholder="Select Category" name="Selectcategory"
                        :required-icon="false" />
                    </div>
                    <div class="label-d-none field prtopo my-auto">
                      <CustomDropdown @update:modelValue="" v-model="FilterSupplierDropdown.SupplierId"
                        :items="FilterSupplierDropdown.SupplierTopOptions" :rules="{ required: false }"
                        placeholder="Select Supplier" name="Selectsupplier" :required-icon="false" />
                    </div>
                    <AddButton btnname="Add" @Click="SupplierAdd" />

                    <AddButton class="blue-txt" btnname="Cancel" @Click="SupplierAddCancel" />
                  </b-col>
                </b-row>
                <SkeletonTableLoader :columns="POheaders" :loading="loading" />
                <!-- {{ POItemTable }}<br />
                {{ IsPOObj.POTableSelectionMode }} -->
                <POETableview v-if="!loading" :rowHover="true" filterDisplay="menu" :loading="loading"
                  responsiveLayout="scroll" :columns="POheaders" :globalFilterFields="globalFilterFields"
                  :data="POItemTable" @selection="POselectedProductFunction"
                  :selectionMode="IsPOObj.POTableSelectionMode" @row-click="RowClick" :seriaNlumber="true">
                  <template v-slot:Add>
                    <span>
                      <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                    </span>
                  </template>
                  <template v-slot:field>
                    <span>
                      <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                    </span>
                  </template>

                  <template v-slot:Level="{ data }">
                    <div class="label-d-none tablefield mb-0">
                      <!-- {{ data.ReOrderLevel }} -->
                      <TextField :required-icon="false" name="" :id="'ReOrderLevel' + `${data.rowNumber}`" label=""
                        :rules="{
                          nonzeroable: true,
                          required: false,
                          decimal: true,
                        }" v-model="data.ReOrderLevel" @keyup="reorderchk(data)" />
                    </div>
                  </template>
                  <template v-slot:supplierslot="{ data }">
                    <div class="label-d-none tablefield mb-0">
                      <CustomDropdown :items="data.supplieroption" v-model="data.LPOSupplierId" :showClear="true"
                        @update:modelValue="filterSupplier(data, 0)">
                      </CustomDropdown>
                    </div>
                  </template>
                  <template v-slot:combinedFieldSlot="{ data }">
                    <span class="spantxt">
                      <template v-if="data.BrandName">{{
                        data.BrandName
                      }}</template>
                      <template v-if="data.BrandName && data.ModelNumberName">/</template>
                      <template v-if="data.ModelNumberName">{{
                        data.ModelNumberName
                      }}</template>
                      <template v-if="
                        (data.BrandName || data.ModelNumberName) &&
                        data.SizeName
                      ">/</template>
                      <template v-if="data.SizeName">{{
                        data.SizeName
                      }}</template>
                    </span>
                  </template>

                  <!-- <template v-slot:action="{ data }">
                    <span>
                      <EditIcon @click="IsItemEdit(data)" />
                      <DeleteIcon
                        @click="IsPOItemDelete(data)"
                        v-if="data.DocType == 18"
                      />
                    </span>
                  </template> -->
                </POETableview>
                <!-- {{ SupplierInfo }} -->
                <b-row v-if="SupplierInfo.length > 0">
                  <b-col>
                    <div class="supplierlistbg">
                      <div class="supplieractionbtnsbg">
                        <i @click="scrollBackward" class="pi pi-arrow-circle-left"></i>
                        <i @click="scrollForward" class="pi pi-arrow-circle-right"></i>
                      </div>
                      <div class="d-flex align-items-center justify-content-between w-90">
                        <div class="supplierdetails scroll-container" ref="scrollContainer">
                          <div class="suppliercardsbg" v-for="item in SupplierInfo">
                            <p>{{ item?.SupplierName }}</p>
                            <OrangeBadge :BadgeValue="item?.ItemCount" />
                          </div>
                        </div>
                        <div class="proceedbtn d-flex me-2">
                          <!-- <p @click="SaveDraft('PO')">Save as draft</p> -->
                          <!-- <Button class="me-2" label="Save as draft" @click="SaveDraft('PO')" /> -->
                          <!-- <div class="savedraftbtn me-2">
                            <p @click="SaveDraft('PO')">Save as draft</p>
                          </div> -->

                          <Button label="Proceed" @click="IsCreatePO()" />
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-row>
      </div>
    </b-container>
  </div>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <POCreateSuccessully :visible="POsuccesspop" @ok="POclosetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AddItemConfirmation :Editmodel="AddItemmodel" @yes="CopyReorderData(confirmval)" @no="AddItemmodel = false"
    :content="msgcontent" />
  <WarningMessage :visible="wariningPopup" :content="warningmsgcontent.warningcontent" @ok="ClosewariningPopup()" />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues"
    :PrintType="PrintType" />

  <Toast />
</template>

<script lang="ts">
import { useToast } from "primevue/usetoast";
import moment from "moment";
import BackToMasters from "../../../../../components/FormComponents/BacktoMaster.vue";
import CustomDropdown from "../../../../../components/FormComponents/Dropdown.vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import Badge from "primevue/badge";
import AddItemsVue from "../../../../../modules/Inventory/components/Transaction/AddItems.vue";
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  reactive,
  watch,
} from "vue";
import NTableview from "../../../../../components/FormComponents/NormalTable.vue";
import PRETableview from "../../../../../components/FormComponents/EditableTable.vue";
import POETableview from "../../../../../components/FormComponents/EditableTable.vue";
import LPOETableview from "../../../../../components/FormComponents/EditableTable.vue";
import ReorderETableview from "../../../../../components/FormComponents/EditableTable.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Item from "../../../../../modules/Inventory/components/Transaction/Item.vue";
import { useRoute, useRouter } from "vue-router";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import cancel from "../../../../../components/GeneralButtons/CancelButtton.vue";
import RequestId from "../../../../../modules/Inventory/components/Transaction/stockwithoutaffect/RequestId.vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import CustomMultiSelect from "../../../../../components/FormComponents/MultiSelectDropdown.vue";
import common from "../../../../../modules/Inventory/Service/WithoutStockAffectService";

import WithoutStockService from "../../../../../modules/Inventory/Service/WithoutStockAffectService";
import CreateSuccessully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import POCreateSuccessully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AddItemConfirmation from "../../../../../components/FormComponents/AddItemsConfirmation.vue";
import WarningMessage from "../../../../../components/FormComponents/WarningMessage.vue";
import SupplierService from "../../../../../modules/Inventory/Service/SupplierMaster";

import SupplierCategoryService from "../../../../../modules/Inventory/Service/SupplierCategoryMappingService";
import QuoteConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import PIConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";

import StoreService from "../../../../../modules/Inventory/Service/StoreService";
import CrystalReportPrintPopUp from "../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import PaymentTermsService from "../../../../../modules/Inventory/Service/PaymentTermsService";
import DeliveryTermsService from "../../../../../modules/Inventory/Service/DeliveryTermsService";
import ItemConfigurationService from "../../../../../modules/Inventory/Service/ItemConfiguration";
import ItemService from "../../../../../modules/Inventory/Service/ItemMasService";
import SupplierCategory from "../../../../../modules/Inventory/Service/SupplierCategoryMappingService";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import StoreDropDown from "../../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";

import WithoutStockAffectService from "../../../../../modules/Inventory/Service/WithoutStockAffectService";
import SupplierMasterservice from "../../../Service/SupplierMaster";
import Datepickers from "../../../../../components/FormComponents/DatePicker.vue";
import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";

import { useReOrderStore } from "../../../../../modules/Inventory/stores/ReorderStore";

export default defineComponent({
  components: {
    Datepickers,
    StoreDropDown,
    Badge,
    AddItemsVue,
    Item,
    PRETableview,
    POETableview,
    LPOETableview,
    ReorderETableview,
    NTableview,
    Footer,
    cancel,
    BackToMasters,
    Headerlayout,
    RequestId,
    TextField,
    CustomMultiSelect,
    CreateSuccessully,
    POCreateSuccessully,
    UpdatedSuccessfully,
    AddItemConfirmation,
    WarningMessage,
    CustomDropdown,
    QuoteConfirmation,
    PIConfirmation,
    CrystalReportPrintPopUp,
    SkeletonTableLoader,
  },
  props: {
    showone: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    debugger;

    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let reOrderStore = useReOrderStore();
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    const toast = useToast();
    let List = ref([]);
    let loading = ref(false);
    let showitemfield = ref(false);
    const items: any = ref([]);
    const displayClass = ref("");
    const ItemTable: any = ref([]);
    const POItemTable: any = ref([]);

    const LPOItemTable: any = ref([]);
    const POHiddenItemTable: any = ref([]);
    const POHiddenItemArray: any = ref([]);
    let ItemRemove: any = ref([]);
    let requestdata: any = ref();
    const ReOrderData: any = ref([]);
    const router = useRouter();
    const route = useRoute();
    const successpop = ref(false);
    const POsuccesspop = ref(false);
    const updatepop = ref(false);
    const AddItemmodel = ref(false);
    const wariningPopup = ref(false);
    const selectedProduct: any = ref([]);
    const LPOselectedProduct: any = ref([]);
    const POselectedProduct: any = ref([]);
    const POselectedProductCount: any = ref(0);
    var supcategory: any = ref();

    const SupplierInfo: any = ref([]);

    let requestdropdown = ref(true);
    let requestValue = ref(false);
    let requestidValue = ref("");
    const dataItems = ref({});
    const CrystalReportPopup = ref(false);

    let StoreDropdownDisable = ref(false);
    let filtercateObj: any = ref([]);
    let StoreId = ref(route.query.Id);
    let status = route.query.status ?? 0;
    let Type = route.query.Type;
    let storebranchmappingid = route.query.storebranchmapid ?? 0;

    const ParamValues = ref({
      requestId: "",
      Id: 0,
      Type: 0,
      DocNo: 0,
      StockTransId: 0,
      storebranchmapid: 0,
      type: 1,
      SupplierId: 0,
      StoreId: 0,
      status: "",
    });

    ParamValues.value.Id = Number(StoreId.value);
    ParamValues.value.StoreId = Number(StoreId.value);
    ParamValues.value.storebranchmapid = Number(storebranchmappingid);

    ParamValues.value.Type = Number(status);
    ParamValues.value.status = String(Type);

    let IsPOObj = ref({
      IsPOUpdate: 0,
      SaveAsDraft: 0,
      LPOTabHideAndShow: false,
      POTableSelectionMode: false,
    });

    const commonItemProps = ref({
      storeId: "",
      type: 0,
    });

    let clases = ref({
      ItemsReOrderTab: 0,
      WithAndWithoutRateTab: 0,
    });

    // For Get Current date and time in sql server format
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const milliseconds = now.getMilliseconds();

    const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}T${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}.${milliseconds
          .toString()
          .padStart(3, "0")}`;
    // end

    const ObjVal = ref({
      Id: 0,
      DocType: "5",
      DocNo: "",
      //DocDate: "2023-03-15T13:40:56.139Z",
      DocDate: formattedDate,
      RefId: 0,
      RefNo: "",
      StoreId: 0,
      FromStore: 0,
      ToStore: 0,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      SupplierId: 0,
      Amount: 0.0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      PaymentTermsId: 0,
      DeliveryTermsId: 0,
      IsDraft: 0,
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      IsServiceLevel: 0,
    });

    const ObjPOVal = ref({
      DocNo: "",
    });

    const grossvalues = ref({
      grossamount: 0.0,
      taxamount: 0.0,
      totaldiscountamount: 0.0,
      transportcharges: 0.0,
      servicecharges: 0.0,
      othercharges: 0.0,
      netamount: 0.0,
      totalqty: 0.0,
    });

    let showFields = {
      // Category: true,
      Name: {
        show: true,
        require: true,
      },
      Batch: {
        show: false,
        require: false,
      },
      PackSize: {
        show: true,
        require: true,
      },
      UnitRate: {
        show: true,
        require: true,
      },
      Qty: {
        show: true,
        require: true,
      },
      // MRP: false,
      //  Discount: false,
      AvailQty: {
        show: false,
        require: false,
      },
      IssuedQty: {
        show: false,
        require: false,
      },
      RequestedQty: {
        show: false,
        require: false,
      },
      Brand: {
        show: true,
        require: false,
      },
      ModelNumber: {
        show: true,
        require: false,
      },
      Size: {
        show: true,
        require: false,
      },
    };

    function ShowItems() {
      showitemfield.value = true;
    }

    const POheaders = [
      {
        header: "Category",
        field: "ItemCategory1",
        class: "smallwidth",
      },
      {
        header: "Code",
        field: "ItemProductId",
        class: "smallwidth",
      },
      // {
      //   header: "HSN Code",
      //   field: "HSNCode",
      // },
      {
        header: "Name",
        field: "Itemname1",

        bodyclass: "boldclass text_overflow2",
        slot: "combinedFieldSlot",
        class: "mediumwidth",
      },
      {
        header: "Supplier",
        field: "",
        bodyclass: "text_overflow2",
        slot: "supplierslot",

        class: "mediumwidth",
      },
      // {
      //   header: "Brand/Model Number/Size",
      //   field: "BrandName",
      //   fieldDisplay: "false",
      //   // class: "mediumwidth",

      //   slot: "combinedFieldSlot"
      // },
      {
        header: "LPO Date",
        field: "LPODate",
        // slot: "SizeIdLPO",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "UOM",
        field: "PurchaseUnitName",
        // slot: "SizeIdLPO",
        class: "smallwidth",
      },

      {
        header: "Avl Qty",
        field: "StockInHand",
        bodyclass: "right_td",
        class: "smallwidth",
      },

      {
        header: "Min",
        field: "MinReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "Max",
        field: "MaxReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "Consumption",
        field: "Consumption",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "Reorder",
        field: "",
        bodyclass: "right_td",
        slot: "Level",
        class: "smallwidth",
        fieldDisplay: "false",
      },

      // {
      //     class: "filterdisplaynone last-column-position",
      //     fieldDisplay: "false",
      //     field: "action",
      //     header: "",
      //     slot: "action",
      //     frozencolumn: true,
      //     sortable: false,
      // },
    ];

    //ReOrder Level Table

    const paramValue = computed(() => {
      return route.query.param as string;
    });
    const globalFilterFields = ref(POheaders.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    const AddData = ref<string[]>([]);

    const handleValues = (valuesArray: string[]) => {
      debugger;
      AddData.value = valuesArray;
      console.log(AddData.value);
    };

    let Entitydata = ref();
    let QueryStringValue3: any = route.query;
    QueryStringValue3 = JSON.parse(QueryStringValue3.data);
    let StoreID = QueryStringValue3["StoreId"];
    let StockWoTransTMId = QueryStringValue3["StockWoTransTMId"];

    let fromStoreBranchMapId =
      Number(QueryStringValue3["storebranchmapid"]) ?? 0;

    commonItemProps.value.storeId = QueryStringValue3["StoreId"];
    Entitydata.value = Number(QueryStringValue3.EntityId) ?? 0;
    let OperationId = Number(QueryStringValue3.OperationId) ?? 0;
    let PRid = 0;
    let param = route.query.param;
    const TodayDate = new Date();

    onMounted(() => {
      debugger;
      // ReadyFunction();
      // Loadstores()
      localStorage.removeItem("PoIdList");

      let SessionUserData = localStorage.getItem("UsersData");
      if (SessionUserData !== null) {
        usersData = JSON.parse(SessionUserData);
      }
      // ItemData.value.FromDate = TodayDate
      //   ItemData.value.ToDate =TodayDate

      suppliercategorydd();
      // IsShowByStockTransIdPO();
    });

    async function ReadyFunction() {
      debugger;

      if (QueryStringValue3["StockWoTransTMId"] == "0" && param == "PR") {
        warningmsgcontent.value.TitleContent = "Raise a PR";
        warningmsgcontent.value.SubmitButtonName = "Send for PR";
        StoreDropdownDisable.value = false;
        //LoadStores();
        await GetCode();
      } else {
        ObjVal.value.DocNo = QueryStringValue3["DocNo"];
      }

      if (QueryStringValue3["StockWoTransTMId"] != "0" && param == "PR") {
        warningmsgcontent.value.TitleContent = "Raise a PR";
        warningmsgcontent.value.SubmitButtonName = "Update PR";
        StoreDropdownDisable.value = true;
        //LoadStores();
        await IsShowByStockTransId(QueryStringValue3["StockWoTransTMId"]);
      }

      if (QueryStringValue3["StockWoTransTMId"] != "0" && param == "PO") {
        warningmsgcontent.value.TitleContent = "Raise a PO";
        warningmsgcontent.value.SubmitButtonName = "Convert to PO";
        StoreDropdownDisable.value = true;

        await GetPOCode();
        //LoadStores();
        // IsShowByStockTransIdPO(QueryStringValue3["StockWoTransTMId"]);
      }
    }

    async function ItemDetailsById(ItemId) {
      debugger;
      return await ItemService.Edit(ItemId, HospitalId);
    }

    //Get Code
    async function GetCode() {
      debugger;
      // let data = {
      //   EntityId: Entitydata.value,
      //   HospitalId: HospitalId,
      //   BranchId: BranchId,
      // };
      // let result: any = await common.getCodeTemplate(data);
      // console.log(result);

      // ObjVal.value.DocNo = result;
    }

    //Get PO Code
    async function GetPOCode() {
      debugger;
      // let data = {
      //   EntityId: 145,
      //   HospitalId: HospitalId,
      //   BranchId: BranchId,
      // };
      // let result: any = await common.getCodeTemplate(data);
      // console.log(result);

      // ObjPOVal.value.DocNo = result;
    }

    const StoreDropdown = ref({
      StoreOptions: [],
      StoreId: ref(),
    });

    // Load Request Id
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    function StoreOnChange() {
      debugger;

      if (
        StoreDropdown.value.StoreId != null &&
        StoreDropdown.value.StoreId != 0
      ) {
        requestid.value.RequestIDOptions = [];
        requestid.value.RequestIDValue = "";
        ItemTable.value = [];
        items.value = [];
        LoadRequestID("N", "");
      }
    }

    const requestid = ref({
      RequestIDOptions: [],
      RequestIDValue: "",
    });

    // Load Request Id
    async function LoadRequestID(Status, value) {
      debugger;
      if (
        StoreDropdown.value.StoreId != null &&
        StoreDropdown.value.StoreId != 0
      ) {
        let PValues = ref({
          statusValue: Status == "N" ? "0,3,5" : "0,3,4,5",
          DocType: 1,
        });

        const result = await WithoutStockService.GetRequestIDs(
          StoreDropdown.value.StoreId.Id,
          "FM",
          PValues.value.statusValue,
          PValues.value.DocType,
          0
        );
        console.log(result);

        if (Status == "N") {
          requestid.value.RequestIDOptions = result["result"].map((item) => {
            item.name = item.DocNo;
            item.value = item.Id;
            return item;
          });
        } else {
          requestid.value.RequestIDOptions = result["result"]
            .map((item) => {
              item.name = item.DocNo;
              item.value = item.Id;
              return item;
            })
            .filter(
              (item) =>
                (item.DocType == 1 && item.Status == 0) ||
                (item.DocType == 1 && item.Status == 5) ||
                (item.Status == 4 && value.includes(item.Id))
            );
        }

        console.log(requestid.value.RequestIDOptions);
      }
    }

    //Request Id OnChange

    let RequestId = "";
    let SavingArray: any = ref([]);

    // const AddItems = (value) => {
    async function AddItems(value) {
      debugger;
      console.log(value);

      items.value = value;

      if (param == "PR") {
        ItemTable.value = value;
      }

      if (param == "PO") {
        POItemTable.value = [];
        POHiddenItemTable.value = [];

        POItemTable.value = [...POItemTable.value, ...value];

        POHiddenItemTable.value = [...POHiddenItemTable.value, ...value];

        ///
        value.forEach((item) => {
          filtercateObj.value.push({
            ItemCategory1: item.ItemCategory1,
            CategoryId: item.CategoryId,
          });
          LoadFilterCategory(filtercateObj.value);
        });
        ///
      }
    }

    let SearchValue = ref({
      inputValue: "",
    });

    function ItemSearchFunction() {
      debugger;
      POselectedProduct.value = [];

      let SearchText = SearchValue.value.inputValue;
      let regex = new RegExp(SearchText, "i");

      try {
        POItemTable.value = POHiddenItemTable.value.filter((f) =>
          regex.test(f.Itemname1)
        );
        console.log(POItemTable);
      } catch (error) {
        alert(error);
      }
    }

    // Load Filter Category
    const FilterCategoryDropdown: any = ref({
      CategoryOptions: [],
      CategoryId: ref(),
    });

    async function LoadFilterCategory(CategoryArray) {
      debugger;
      //   alert(JSON.stringify(CategoryArray));
      //   const uniqueCategoryItems = CategoryArray.filter(
      //     (item) =>
      //       !FilterCategoryDropdown.value.CategoryOptions.some(
      //         (option) => option.value === item.CategoryId
      //       )
      //   );

      //   FilterCategoryDropdown.value.CategoryOptions = [
      //     ...FilterCategoryDropdown.value.CategoryOptions,
      //     ...uniqueCategoryItems.map((item) => ({
      //       name: item.ItemCategory1,
      //       value: item.CategoryId,
      //     })),
      //   ];
      // alert("1");
      const uniqueItems = Array.from(
        new Map(
          CategoryArray.map((item) => [
            item.ItemCategory1 + item.CategoryId,
            item,
          ])
        ).values()
      );
      FilterCategoryDropdown.value.CategoryOptions = uniqueItems.map(
        (item: any) => ({
          name: item.ItemCategory1,
          value: item.CategoryId,
        })
      );

      // alert(JSON.stringify(FilterCategoryDropdown.value.CategoryOptions));
    }

    async function FilterCategoryOnChange(CategoryId) {
      debugger;
      FilterSupplierDropdown.value.SupplierOptions = [];
      FilterSupplierDropdown.value.SupplierId = ref();

      if (CategoryId != null) {
        FilterCategoryDropdown.value.CategoryId = CategoryId;

        await LoadFilterSuppliers(CategoryId);
        // IsShowByStockTransIdPO();

        for (let i = 0; i < POItemTable.value.length; i++) {
          POItemTable.value[i].supplieroption =
            FilterSupplierDropdown.value.SupplierOptions;
        }

        let regex = new RegExp(CategoryId, "i");
        POItemTable.value = POHiddenItemTable.value.filter((f) =>
          regex.test(f.CategoryId)
        );

        IsPOObj.value.POTableSelectionMode = true;
      } else {
        ItemSearchFunction();
      }
    }

    // Load Filter Supplier
    const FilterSupplierDropdown: any = ref({
      SupplierOptions: ref(),
      SupplierTopOptions: ref(),

      SupplierId: ref(),
    });

    async function LoadFilterSuppliers(CategoryId) {
      debugger;

      const response = await SupplierCategory.GetSupplierByMultipleCategory(
        CategoryId,
        usersData.BranchId,

        usersData.OrganizationId
      );

      // FilterSupplierDropdown.value.SupplierOptions = supcategory.value.map((item) => {
      //   item.name = item.Name;
      //   item.value = item.Id;
      //   item.CategoryId = item.ItemCategoryId;
      //   return item;
      // });
      // alert(JSON.stringify(response["result"][0]))

      FilterSupplierDropdown.value.SupplierOptions = response["result"]
        // .filter((item) => item.BranchId == BranchId)

        .map((item) => {
          item.name = item.SupplierName;
          item.value = item.SupplierId;
          item.CategoryId = item.ItemCategoryId;
          return item;
        });
      // alert(FilterCategoryDropdown.value.CategoryId)
      if (FilterCategoryDropdown.value.CategoryId) {
        FilterSupplierDropdown.value.SupplierTopOptions = response["result"]
          // .filter((item) => item.BranchId == BranchId)

          .map((item) => {
            item.name = item.SupplierName;
            item.value = item.SupplierId;
            item.CategoryId = item.ItemCategoryId;
            return item;
          });
      }
    }

    const selectedIndices: any = ref([]);
    const selectedItems: any = ref([]);

    function POselectedProductFunction(value) {
      debugger;

      POselectedProduct.value = value;
      selectedItems.value = value;

      POselectedProductCount.value = POselectedProduct.value.length;

      // Get the indices of selected rows
      selectedIndices.value = [];
      for (let i = 0; i < value.length; i++) {
        selectedIndices.value.push(POItemTable.value.indexOf(value[i]));
      }

      // Now selectedIndices array contains the indices of selected rows
      console.log(selectedIndices);
    }

    function SupplierAddCancel() {
      debugger;
      FilterCategoryOnChange(null);
      SupplierInformation();
    }
    function setReorderlevel() {
      router.push({
        path: "/setreOrderLevel",

        query: {
          data: JSON.stringify(QueryStringValue3),
          param: "setreOrderLevel",
        },
        // query: {
        //   PRId: StockWoTransTMId,
        // },
      });
    }

    function SupplierAdd() {
      debugger;
      let TempMsg =
        POselectedProduct.value.length == 0
          ? "Select Items"
          : FilterSupplierDropdown.value.SupplierId == null ||
            FilterSupplierDropdown.value.SupplierId == 0
            ? "Choose Supplier"
            : "";
      let TempQtyMsg: any = ref();

      POselectedProduct.value.forEach((item) => {
        if (item.ReOrderLevel === 0) {
          TempMsg = "Add the Reorder Qty for the Items";
        }
      });
      if (TempMsg != "") {
        toast.add({
          severity: "info",
          summary: TempMsg,
          detail: "",
          life: 3000,
        });
      }
      // else if (TempQtyMsg != ""){
      //   toast.add({
      //     severity: "info",
      //     summary: TempQtyMsg,
      //     detail: "",
      //     life: 3000,
      //   });
      // }
      else {
        //ItemTable

        let SupObj = FilterSupplierDropdown.value.SupplierOptions.find(
          (item) => item.SupplierId == FilterSupplierDropdown.value.SupplierId
        );

        // Map ItemTable for selected indices
        POItemTable.value = POItemTable.value.map((item, index) => {
          if (selectedIndices.value.includes(index)) {
            let existingItems = POHiddenItemTable.value.filter(
              (existingItem) => existingItem.SupplierId === SupObj.SupplierId
            );

            if (existingItems.length > 0) {
              item.DocNo = existingItems[0].DocNo;
              item.StockWOTransId = existingItems[0].StockWOTransId;
              item.RefId = existingItems[0].RefId;
              item.RefNo = existingItems[0].RefNo;
            } else {
              if (item.DocType == 18) {
                item.StockWOTransId = 0;
                item.RefId = 0;
              } else if (item.DocType == 5) {
                item.StockWOTransId = 0;
              }
            }

            item.SupplierName = SupObj.SupplierName;
            item.SupplierId = SupObj.SupplierId;
          }
          return item;
        });

        IsPOObj.value.POTableSelectionMode = false;
        FilterCategoryOnChange(null);
        SupplierInformation();
        // toast.add({
        //   severity: "info",
        //   summary: "Add the quantity for the Items",
        //   detail: "",
        //   life: 3000,
        // });
        console.log(SupObj);
      }
    }

    function SupplierInformation() {
      debugger;
      // Count rows for each supplier
      const supplierRowCount = {};
      POItemTable.value.forEach((item) => {
        const supplierId = item.SupplierId;
        if (supplierId) {
          if (!supplierRowCount[supplierId]) {
            supplierRowCount[supplierId] = {
              SupplierName: item.SupplierName,
              ItemCount: 0,
              Itemsdata: {},
            };
          }
          // supplierRowCount[supplierId].Itemsdata.push(item);

          supplierRowCount[supplierId].ItemCount++;
        }
      });

      // Convert supplierRowCount object to an array of supplier counts
      SupplierInfo.value = Object.values(supplierRowCount);

      console.log("SupplierInfo", SupplierInfo.value);
    }

    //Load Items by StockWoTrans Id
    async function IsShowByStockTransId(StockTransTMId) {
      debugger;

      const result = await WithoutStockService.GetByStockWOTransId(
        StockTransTMId
      );

      result["result"] = result["result"].map((item) => {
        item.SupplierId = item.ItemSupplierId;
        item.SupplierName = item.ItemSupplierName;
        return item;
      });

      items.value = result["result"];
      ItemTable.value = result["result"];

      StoreDropdown.value.StoreId = result["result"][0]["FromStore"];
      await LoadRequestID("E", result["result"][0]["RefNo"]);
      requestid.value.RequestIDValue = result["result"][0]["RefNo"]
        .split(",")
        .map((i) => Number(i));
      RequestId = result["result"][0]["RefNo"];
    }

    //Load Items by StockWoTrans Id
    async function IsShowByStockTransIdPO() {
      debugger;
      // alert(JSON.stringify(ItemData.value))
      loading.value = true;
      let result: any;
      const fromDate = moment(ItemData.value.FromDate).format("YYYY-MM-DD");
      const toDate = moment(ItemData.value.ToDate).format("YYYY-MM-DD");

      result = await WithoutStockAffectService.GetReOrderLevelListfromto(
        QueryStringValue3["StoreId"],
        fromDate,
        toDate,
        HospitalId,
        BranchId
      );
      // alert(JSON.stringify(QueryStringValue3.StoreId))
      items.value = result["result"];
      if (items.value.length != 0) {
        result["result"] = result["result"].map((item, index) => {
          item.supplierId = item.POSupplierId;
          item.supplieroption =
            FilterSupplierDropdown.value.SupplierTopOptions == undefined
              ? []
              : FilterSupplierDropdown.value.SupplierTopOptions;

          item.rowNumber = index + 1;
          return item;
        });

        ObjVal.value.StoreBrMapId = result["result"][0].StoreBrMapId;
        ObjVal.value.FromStoreBrMapId = result["result"][0].FromStoreBrMapId;
        ObjVal.value.ToStoreBrMapId = result["result"][0].ToStoreBrMapId;

        POItemTable.value = result["result"];
        POHiddenItemTable.value = result["result"];

        POItemTable.value.forEach((item) => {
          filtercateObj.value.push({
            ItemCategory1: item.ItemCategory1,
            CategoryId: item.CategoryId,
          });
          // LoadFilterCategory(filtercateObj.value);
        });
        await LoadFilterCategory(filtercateObj.value);
        await SupplierInformation();
      }

      // const ItemIds = Array.from(
      //   new Set(result["result"].map((item) => item.ItemId))
      // ).join(",");

      loading.value = false;
    }
    async function filterSupplier(data, NumVal) {
      debugger;
      console.log(data);

      const response = await LoadFilterSuppliers(data.CategoryId);

      if (NumVal == 0) {
        data.supplieroption = FilterSupplierDropdown.value.SupplierOptions;
        // .filter((x) =>
        //   response["result"].Brand.split(",").includes(String(x.Id))
        // );
        if (data.supplieroption.length == 0) {
          data.supplieroption = FilterSupplierDropdown.value.SupplierOptions;
        }
      } else if (NumVal == 1) {
        data.supplieroption = FilterSupplierDropdown.value.SupplierOptions;
        // .filter((x) =>
        //   response["result"].Brand.split(",").includes(String(x.Id))
        // );
        if (data.supplieroption.length == 0) {
          data.supplieroption = FilterSupplierDropdown.value.SupplierOptions;
        }
      }
      // alert(JSON.stringify(data.supplieroption));
    }
    //Item Edit
    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
      displayClass.value = "show";
    }

    function TotalGrossCalc(value1) {
      debugger;
      grossvalues.value.grossamount = value1.grossamount;
      grossvalues.value.totalqty = value1.totalqty;
      grossvalues.value.taxamount = value1.taxamount;
      grossvalues.value.totaldiscountamount = value1.totaldiscountamount;
      grossvalues.value.othercharges = value1.totalothercharges;
      grossvalues.value.transportcharges = value1.totaltransportcharges;
      grossvalues.value.servicecharges = value1.totalservicecharges;
      grossvalues.value.netamount = value1.netamount;
    }

    function IsSubmit(Value) {
      debugger;
      IsCreatePO();
    }

    function SaveDraft(Value) {
      debugger;
      IsPOObj.value.SaveAsDraft = 1;
      if (Value == "PO") {
        if (IsPOObj.value.IsPOUpdate == 0) {
          IsCreatePO();
        } else {
        }
      } else {
      }
    }

    // Create PR

    // Create PO
    async function IsCreatePO() {
      debugger;
      let result: any = "";
      let message;
      let id = 0;
      let arraylength = POItemTable.value.length;
      let QuantityValues: any = [];

      for (let i = 0; i < selectedItems.value.length; i++) {
        let qty = selectedItems.value[i].ReOrderLevel;
        QuantityValues.push(selectedItems.value[i]["ReOrderLevel"]);
      }
      // Filtering out non-numeric values and converting them to numbers
      let numericValues: number[] = QuantityValues.filter(
        (value) => typeof value === "number" || !isNaN(Number(value))
      ).map((value) => Number(value));

      // Calculating the sum of the numeric values
      let SumValues: number = numericValues.reduce(
        (acc, value) => acc + value,
        0
      );
      console.log(SumValues);
      if (SumValues > 0) {
        let suppliers: any = [];
        for (let i = 0; i < selectedItems.value.length; i++) {
          let supplier = selectedItems.value[i].SupplierId;
          if (selectedItems.value[i]["SupplierId"] != 0) {
            suppliers.push(selectedItems.value[i]["SupplierId"]);
          }
        }
        let uniqueSuppliers = suppliers.filter((supplier, index) => {
          return suppliers.indexOf(supplier) === index;
        });
        console.log(uniqueSuppliers);
        let filteredSupplierIds: any = uniqueSuppliers;
        const filteredItems = selectedItems.value.filter((item) => {
          return (
            item.hasOwnProperty("SupplierId") &&
            filteredSupplierIds.includes(item.SupplierId)
          );
        });
        console.log("filteredItems", filteredItems);
        const groupedItems = filteredItems.reduce(
          (accumulator, currentValue) => {
            const SupplierId = currentValue.SupplierId;
            if (!accumulator[SupplierId]) {
              accumulator[SupplierId] = [];
            }
            accumulator[SupplierId].push(currentValue);
            return accumulator;
          },
          {}
        );
        console.log(groupedItems);
        for (const key in groupedItems) {
          const currentArray = groupedItems[key];
          ObjVal.value.Id = 0;
          ObjVal.value.DocType = "5";
          ObjVal.value.RefId = QueryStringValue3["StockWoTransTMId"];
          ObjVal.value.RefNo =
            String(QueryStringValue3["DocNo"]) == "0"
              ? ""
              : String(QueryStringValue3["DocNo"]);
          ObjVal.value.StoreId = StoreID;
          ObjVal.value.FromStore = StoreID;
          ObjVal.value.ToStore = StoreDropdown.value.StoreId;
          ObjVal.value.Amount = grossvalues.value.grossamount;
          ObjVal.value.SupplierId = currentArray[0]["SupplierId"];
          ObjVal.value.PaymentTermsId = 0;
          ObjVal.value.DeliveryTermsId = 0;
          ObjVal.value.IsDraft = 1;
          ObjVal.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
          ObjVal.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
          ObjVal.value.BranchId = BranchId;
          ObjVal.value.HospitalId = HospitalId;
          ObjVal.value.ModifiedBy = UserId;
          ObjVal.value.CreatedBy = UserId;
          ObjVal.value.EntityId = 3044;
          ObjVal.value.EntityOperationId = 3044001;
          ObjVal.value.DeptRoleId = rolesData.DeptRoleMapId;
          ObjVal.value.IsServiceLevel = 5;

          ObjVal.value.StoreBrMapId = QueryStringValue3["storebranchmapid"];
          // ObjVal.value.DeptRoleId = rolesData.DeptRoleMapId;

          if (ObjVal.value.Id === 0) {
            result = await WithoutStockService.createStockWOTM(ObjVal.value);
            id = result["result"];
            if (id != 0) {
              reOrderStore.PoIdList.push(id);
            }
          }

          // else {
          //   result = await WithoutStockService.updateStockWOTM(ObjVal.value);
          //   id = currentArray[0]["StockWOTransId"];
          // }
          message = result["ErrorInfo"].ErrorCode;

          let POarr: any = [];
          let PRDetailsarr: any = [];
          if (message == null) {
            debugger;
            for (let i = 0; i < currentArray.length; i++) {
              if (currentArray[i]["ReOrderLevel"] > 0) {
                let obj = {};
                let DetailsObj = {};

                if (currentArray[i]["DocType"] == 18) {
                  PRstockDetailsIds.push(currentArray[i]["StockDetailsId"]);
                  currentArray[i]["StockDetailsId"] = 0;
                }

                (obj["Id"] = currentArray[i]["StockDetailsId"]),
                  (obj["ItemId"] = currentArray[i]["ItemId"]),
                  (obj["Qty"] = currentArray[i]["ReOrderLevel"]),
                  (obj["RefId"] = id),
                  (obj["PackSizeId"] = currentArray[i]["PackSizeId"]),
                  (obj["HSNId"] = currentArray[i]["HSNId"]),
                  (obj["Rate"] =
                    currentArray[i]["UnitRate"] *
                    currentArray[i]["ReOrderLevel"]),
                  (obj["UnitRate"] = currentArray[i]["UnitRate"]),
                  (obj["CreatedAt"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  )),
                  (obj["ModifiedAt"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  )),
                  (obj["CreatedBy"] = UserId),
                  (obj["ModifiedBy"] = UserId),
                  (obj["Brand"] =
                    currentArray[i]["Brand"] == null ||
                      currentArray[i]["Brand"] == undefined
                      ? 0
                      : currentArray[i]["Brand"]),
                  (obj["ModelNumber"] =
                    currentArray[i]["ModelNumber"] == null ||
                      currentArray[i]["ModelNumber"] == undefined
                      ? 0
                      : currentArray[i]["ModelNumber"]),
                  (obj["Size"] =
                    currentArray[i]["Size"] == null ||
                      currentArray[i]["Size"] == undefined
                      ? 0
                      : currentArray[i]["Size"]),
                  (obj["Status"] = 0),
                  (POarr[i] = obj);
                ItemRemove.value.push(obj);
              }
            }
            let result = await WithoutStockService.createStockWODetails(POarr);
            // reOrderStore.PoIdList.push(result["result"]);
            // if (PRstockDetailsIds.length > 0) {
            //   PRstockDetailsIds.forEach((stockDetailsId) => {
            //     PRDetailsarr.push({
            //       Id: stockDetailsId,
            //       Status: 1, // Assuming you want to set the status to 0
            //     });
            //   });

            //   if (PRDetailsarr.length > 0) {
            //     let response = await WithoutStockService.UpdateStatusStockWODetailsTD(
            //       PRDetailsarr
            //     );
            //   }
            // }

            message = result["ErrorInfo"].ErrorCode;
          } else {
            alert("Somthing went wrong");
            return;
          }
          console.log();
        }

        if (message == null) {
          if (IsPOObj.value.SaveAsDraft == 1) {
            alert(
              "your data has been saved for future editing. You can continue to work on your submission later."
            );
            router.back();
          } else {
            let polist = reOrderStore.PoIdList.join();
            localStorage.setItem(
              "PoIdList",
              JSON.stringify(reOrderStore.PoIdList)
            );
            router.push({
              path: "/reOrderToPO",

              query: {
                data: JSON.stringify(QueryStringValue3),
                param: "reOrder",
              },
              // query: {
              //   PRId: StockWoTransTMId,
              // },
            });
          }
        } else {
          alert("Somthing went wrong");
          return;
        }
        // }
      } else {
        toast.add({
          severity: "info",
          summary: "Add the quantity for the Items",
          detail: "",
          life: 3000,
        });
        return;
      }
    }

    // Update PO against PR

    const separatedItems = {};
    const itemsWithoutStockWOTransId: any = [];
    let itemsWithStockWOTransIdZero: any = [];
    let PRstockDetailsIds: any = [];

    // Create LPO

    function selectedProductFunction(value) {
      debugger;
      selectedProduct.value = value;
    }

    //ReOrder Level Table

    //Delete ReOrder level Items
    async function IsReOrderDelete(data) {
      debugger;
      let msg = null;

      if (msg == null) {
        ReOrderData.value = ReOrderData.value.filter(
          (item) => item["ItemId"] !== data.ItemId
        );
      }
      console.log(ReOrderData.value);
    }

    let msgcontent = ref({ contentvalue: "" });
    let warningmsgcontent = ref({
      warningcontent: "",
      TitleContent: "",
      SubmitButtonName: "",
    });

    const confirmval = ref();

    function AddSingleConfirmation(val) {
      debugger;
      confirmval.value = val;
      if (ReOrderData.value == "") {
        warningmsgcontent.value.warningcontent = "There is no Items.";
        wariningPopup.value = true;
      } else if (selectedProduct.value == "" || selectedProduct.value == null) {
        warningmsgcontent.value.warningcontent = "Please Select the Items.";
        wariningPopup.value = true;
      } else {
        msgcontent.value.contentvalue =
          "Do you want to add selected items to request ?";
        AddItemmodel.value = true;
      }
    }

    function AddAllConfirmation(val) {
      debugger;
      confirmval.value = val;
      if (ReOrderData.value == "") {
        warningmsgcontent.value.warningcontent = "There is no Items.";
        wariningPopup.value = true;
      } else {
        msgcontent.value.contentvalue =
          "Do you want to add all items to request ?";
        AddItemmodel.value = true;
      }
    }

    function ClosewariningPopup() {
      debugger;
      wariningPopup.value = false;
    }

    function CopyReorderData(selectValue) {
      debugger;

      let dataArray: any = [];
      dataArray = JSON.parse(JSON.stringify(items.value));
      let selectedArray: any = [];
      let checkArray =
        selectValue == "All" ? ReOrderData.value : selectedProduct.value;
      selectedArray = JSON.parse(JSON.stringify(checkArray));
      dataArray.map((item: any) => {
        const item2 = selectedArray.find(
          (data: any) => data.ItemId == item.ItemId
        );
        if (item2) {
          item.ItemQuantity =
            parseInt(item.ItemQuantity) + parseInt(item2.ItemQuantity);
        }
      });

      console.log(items.value);

      let arr1: any = [];

      arr1 = selectedArray.filter(
        (value) => !dataArray.some((i1) => i1.ItemId == value.ItemId)
      );

      for (let i = 0; i < arr1.length; i++) {
        dataArray.push(arr1[i]);
      }

      ItemTable.value = dataArray;

      items.value = dataArray;
      dataItems.value = items.value;
      selectedProduct.value = null;

      AddItemmodel.value = false;
      clases.value.ItemsReOrderTab = 0;
    }
    let todateDisabled = ref(true);
    function IsdateClear() {
      todateDisabled.value = false;
      ItemData.value.ToDate = ref();
    }

    function closetrigger() {
      setupHistoryManagement(router, 5);
      localStorage.removeItem("PoIdList");

      successpop.value = false;
      updatepop.value = false;
    }

    function POclosetrigger() {
      POsuccesspop.value = false;
      setupHistoryManagement(router, 5);

      // router.push({
      //   path: "/StoreTabDetails",
      //   query: {
      //     status: 1,
      //     Id: StoreID,
      //     Type: "StoreId",
      //     storename: "",
      //   },
      // });
    }
    async function suppliercategorydd() {
      debugger;
      try {
        const dataresponse = await SupplierMasterservice.GetSuppliersByStoreId(
          QueryStringValue3["StoreId"] ?? 0,
          session.BranchId
        );

        console.log(dataresponse);
        supcategory.value = dataresponse["result"]
          .filter((i1) => i1.IsActive == true)
          .map((item: any) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }
    const onDropdownBlur = () => {
      console.log("js");
      //requestdropdown.value = false;
    };

    function RowClick(data) {
      debugger;
      // LPOselectedProduct.value.push(data.data);
    }

    const ParameterValues = ref({ Id: 0 });
    const PrintType = ref({ Type: "S", FormId: 41, ModuleId: 3 });

    function PrintCrystalReport(Id) {
      debugger;
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = Id;
    }
    let ItemData = ref({
      FromDate: ref(),
      ToDate: ref(),
    });

    function reorderchk(data) {
      debugger;
      const regex = /^[0-9]*$/;
      if (!regex.test(data.ReOrderLevel)) {
        toast.add({
          severity: "warn",
          summary: "This field Allows only numeric",
          detail: "",
          life: 3000,
        });
        data.ReOrderLevel = "";
      }
    }

    function SelectStore(value) {
      debugger;
      if (value) {
        ObjVal.value.ToStore = value.Id;
        ObjVal.value.ToStoreBrMapId = value.StoreBranchMapId;
      }
    }
    const scrollContainer: any = ref(null);

    const scrollForward = () => {
      if (scrollContainer.value) {
        scrollContainer.value.scrollLeft += 50;
      }
    };

    const scrollBackward = () => {
      if (scrollContainer.value) {
        scrollContainer.value.scrollLeft -= 50;
      }
    };

    return {
      setReorderlevel,
      scrollContainer,
      scrollForward,
      scrollBackward,
      todateDisabled,
      SelectStore,
      QueryStringValue3,
      TodayDate,
      IsShowByStockTransIdPO,
      ItemData,
      LoadFilterSuppliers,
      filterSupplier,
      selectedItems,
      IsCreatePO,
      StoreID,
      showitemfield,
      ShowItems,
      globalFilterFields,
      filters,
      items,
      loading,
      paramValue,
      requestid,
      GetCode,
      handleValues,
      AddItems,
      List,
      LoadRequestID,
      ObjVal,
      IsSubmit,
      showFields,
      IsItemEdit,
      dataItems,
      commonItemProps,
      IsShowByStockTransId,
      IsdateClear,
      closetrigger,
      successpop,
      updatepop,
      ReOrderData,

      selectedProduct,
      selectedProductFunction,
      ReadyFunction,
      IsReOrderDelete,
      CopyReorderData,
      AddItemmodel,
      wariningPopup,
      ClosewariningPopup,
      AddSingleConfirmation,
      AddAllConfirmation,
      msgcontent,
      warningmsgcontent,
      confirmval,
      TotalGrossCalc,
      displayClass,
      clases,
      requestdropdown,
      requestValue,
      requestidValue,
      onDropdownBlur,
      requestdata,
      StoreDropdown,
      StoreOnChange,
      ItemTable,
      ObjPOVal,
      param,
      POheaders,

      POItemTable,

      LPOItemTable,
      POsuccesspop,
      POclosetrigger,
      CrystalReportPopup,
      ParameterValues,
      PrintType,

      LPOselectedProduct,

      RowClick,
      StoreDropdownDisable,

      //
      FilterCategoryDropdown,
      FilterCategoryOnChange,
      FilterSupplierDropdown,
      ItemSearchFunction,
      SearchValue,
      POselectedProduct,
      POselectedProductFunction,
      POselectedProductCount,
      SupplierAdd,
      SupplierAddCancel,
      SupplierInfo,
      SaveDraft,
      POHiddenItemArray,
      IsPOObj,
      reorderchk,
    };
  },
  created() { },
});
</script>
<style lang="scss">
.requestlabel {
  display: block !important;
}

.spantxt {
  font-size: 11px;
  color: grey;
}

.prtopo .p-dropdown.p-dropdown-clearable .p-dropdown-label {
  padding-right: 0.5rem !important;
}

.proceedbtn .p-button {
  background-color: #3096ff;
  padding: 5px 15px;
  border: 1px solid #3096ff;

  .p-button-label {
    font-weight: 500;
  }
}

.proceedbtn .p-button:hover {
  background-color: #3096ff !important;
  padding: 5px 15px;
  border: 1px solid #3096ff;
}

.prtable .p-tabview .p-tabview-nav {
  width: max-content !important;
}
</style>
<style lang="scss" scoped>
.actioncardbg {
  border: 1px solid #e1e1e1;
  align-items: center;
  padding: 10px;
  background-color: #f9fbfc;
  border-radius: 5px;
  margin: 15px 0;

  .selectedcount {
    font-weight: 500;
  }
}

.supplierlistbg {
  background-color: #000000;
  border: 1px solid #303132;
  display: flex;
  align-items: center;

  .supplieractionbtnsbg {
    border-right: 1px solid #e1e1e1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 10px 5px;
    width: 100px;

    .pi {
      font-size: 25px;
    }
  }

  .supplierdetails {
    //   width: 850px;
    width: 950px;
    margin-right: 21px;
    overflow: auto;
    display: flex;
    align-items: center;

    .suppliercardsbg {
      border-right: 1px solid #e1e1e1;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      color: #ffffff;
      min-width: 250px;
    }
  }

  .proceedbtn {
    float: right;
  }
}

.savedraftbtn {
  border: 1px solid #999999;
  padding: 5px 15px;
  width: max-content;
  border-radius: 5px;
  background-color: #ffffff;

  p {
    color: #999999;
  }
}

.scroll-container {
  overflow-x: auto;
  white-space: nowrap;
  border: 1px solid #ccc;
}

.w-90 {
  width: 90%;
}

.card-search .pi-search {
  position: absolute !important;
  top: 0.75rem;
  left: 0.55rem;
  color: #e1e1e1;
}
</style>
